module.exports = __webpack_public_path__ + "static/media/uberlandiaBackground02.e962fee7.jpg";